import React from 'react'
import Svg from '../Svg'
import { SvgProps } from '../types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 33 24" {...props}>
      <path
        d="M5.86645 18.3211C6.06227 18.1339 6.32774 18.0287 6.60453 18.0287H32.1429C32.6081 18.0287 32.841 18.5671 32.5119 18.8818L27.4656 23.7076C27.2698 23.8948 27.0043 24 26.7275 24H1.18913C0.723942 24 0.491038 23.4616 0.820095 23.1468L5.86645 18.3211Z"
        fill="white"
      />
      <path
        d="M5.86645 0.292446C6.06224 0.105181 6.32772 -9.35183e-06 6.60453 6.23587e-10H32.1429C32.6081 6.23587e-10 32.841 0.538411 32.5119 0.853158L27.4656 5.6789C27.2698 5.86612 27.0043 5.97128 26.7275 5.97129H1.18913C0.723942 5.97129 0.491038 5.43288 0.820095 5.11819L5.86645 0.292446Z"
        fill="white"
      />
      <path
        d="M27.4656 9.24934C27.2698 9.06212 27.0043 8.95696 26.7275 8.95696H1.18913C0.723942 8.95696 0.491038 9.49537 0.820095 9.81006L5.86645 14.6358C6.06224 14.8231 6.32772 14.9283 6.60453 14.9282H32.1429C32.6081 14.9282 32.841 14.3898 32.5119 14.0751L27.4656 9.24934Z"
        fill="white"
      />
    </Svg>
  )
}

export default Icon
